<template>
  <div
    class="d-flex-column justify-start gap-md-10 align-start gap-36"
    style="margin-top: 10px"
  >
    <LazyPageCategoryPageRaidBC />
    <MmoPackDetail v-if="!$isMobile() && !$isTablet()" />
    <div
      class="d-flex-row height-max-content justify-start gap-32 raid_filter_container md-row-to-col align-md-start"
      v-if="!$isMobile() && !$isTablet()"
    >
      <div class="filter_item_min">
        <ServerPicker />
      </div>
      <KeystoneLevelPicker />
      <DungeonPicker />
    </div>
    <div
      class="d-flex-column gap-20 justify-start align-start height-max-content"
      v-else-if="$isMobile() || $isTablet()"
    >
      <ServerPicker />
      <KeystoneLevelPicker />
    </div>

    <DungeonItemPicker v-if="!$isMobile() && !$isTablet()" :src="'test'" />
    <!-- <div
      class="d-flex-column justify-start align-start gap-24"
      v-if="!$isMobile() && !$isTablet()"
    >
      <template v-for="key in keys">
        <div
          class="pack_text_detail"
          v-html="getGamePack?.pack_description_detail[key]"
        ></div>
      </template>
      <MythicItems />
    </div> -->
  </div>
</template>

<script setup>
import ServerPicker from "./pickers/ServerPicker.vue";
import KeystoneLevelPicker from "./cart-pickers/KeystoneLevelPicker.vue";
import DungeonPicker from "./cart-pickers/DungeonPicker.vue";
import MythicItems from "./raid/MythicItems.vue";
import DungeonItemPicker from "./pickers/DungeonPicker.vue";
import MmoPackDetail from "./pickers/MmoPackDetail.vue";
// import { onMounted } from "vue";

const { getGame, getGamePack } = useGameStore();
const checkoutStore = useCheckoutStore();
const keys = ["what_you_get", "mythic_plus_rewards"];

const handleDetails = () => {
  checkoutStore.clearCheckout();

  const account_sharing = getGamePack?.pack_options?.find(
    (op) => op.const_title === "account_sharing"
  );

  const non_timed = getGamePack?.pack_extra_options?.find(
    (op) => op.description === "mythic_run" && op.title === "Non Timed"
  );
  const standard = getGamePack?.pack_options?.find(
    (op) => op.const_title === "standard"
  );

  const extra_gold = getGamePack.pack_extra_options?.find(
    (op) => op.description === "gold_selector"
  );

  const firstRole = getGame?.roles ? getGame?.roles[0] : null;
  if (firstRole) {
    checkoutStore.setOneRole({
      roleId: firstRole.id,
    });
  }

  if (account_sharing) {
    checkoutStore.setPackOptions({
      options: [account_sharing.id],
    });
  }
  if (non_timed) {
    checkoutStore.setPackExtraOptions({
      mythic_run: non_timed.id,
    });
  }
  if (standard) {
    checkoutStore.setPackOptions({
      options: [...checkoutStore.getPackOptions, standard.id],
    });
  }
  if (extra_gold) {
    checkoutStore.setPackExtraOptions({
      gold: extra_gold.id,
    });
  }
  checkoutStore.setServer(1);
  checkoutStore.setPlatform({
    platform: 1,
  });
  checkoutStore.setDetails({
    desiredKeystone: 15,
    numberOfMythic: 1,
  });
  checkoutStore.setPackExtraOptions({
    dungeon: 5,
    trader: 1,
  });
  checkoutStore.setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
};

handleDetails();
onMounted(() => {
  checkoutStore.setCalculating();
});
</script>
